<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">

  <ng-container widget-body>
    <div class="twitterContainer">
      <mojo-twitter-timeline [href]="'https://twitter.com/aurora_propm'" title="Aurora"></mojo-twitter-timeline>
    </div>
  </ng-container>

</mojo-widget>
